import { useState, useEffect } from 'react'
import Modal from '../Modal'
import { getGruposPlanta } from '../../api/client'
import { miembrosDe, responsableTrasGrupo } from './otLogica'
import { hoyLocal } from '../partes/fechas'

const PRIORIDADES = ['critica', 'alta', 'media', 'baja']

// The planning an OT in execution lacks, completed before assigning someone:
// priority, committed date (not past), work group and responsable (the
// group's supervisor by default); estimated hours optional. Only what changes
// is sent -- an OT already overdue keeps its date unless a new one is set.
export default function PlanificarAsignacion({ persona, ot, faltan, error, ocupado, t, onClose, onConfirmar }) {
  const inicial = {
    prioridad: ot.prioridad || '',
    fecha_compromiso: ot.fecha_compromiso || '',
    grupo_id: String(ot.grupo_id ?? ot.grupo?.id ?? ''),
    responsable_id: String(ot.responsable_id ?? ot.responsable?.id ?? ''),
    horas_estimadas: ot.horas_estimadas ?? '',
  }
  const [v, setV] = useState(inicial)
  const [grupos, setGrupos] = useState([])
  const [marcadas, setMarcadas] = useState(error ? faltan : [])
  useEffect(() => {
    getGruposPlanta().then(setGrupos).catch(() => {})
  }, [])

  const set = (k, x) => { setV(p => ({ ...p, [k]: x })); setMarcadas([]) }
  const elegirGrupo = (id) => {
    // The responsable is one of the group's people: kept if in it, else its supervisor.
    setV(p => ({ ...p, grupo_id: id, responsable_id: responsableTrasGrupo(grupos, id, p.responsable_id) }))
    setMarcadas([])
  }
  const confirmar = (e) => {
    e.preventDefault()
    const fs = []
    if (!v.prioridad) fs.push('prioridad')
    if (!v.fecha_compromiso) fs.push('fecha_compromiso')
    else if (v.fecha_compromiso !== inicial.fecha_compromiso && v.fecha_compromiso < hoyLocal()) fs.push('fecha_compromiso_pasada')
    if (!v.grupo_id) fs.push('grupo')
    if (!v.responsable_id) fs.push('responsable')
    if (fs.length) { setMarcadas(fs); return }
    const out = {}
    if (v.prioridad !== inicial.prioridad) out.prioridad = v.prioridad
    if (v.fecha_compromiso !== inicial.fecha_compromiso) out.fecha_compromiso = v.fecha_compromiso
    if (v.grupo_id !== inicial.grupo_id) out.grupo_id = Number(v.grupo_id)
    if (v.responsable_id !== inicial.responsable_id) out.responsable_id = Number(v.responsable_id)
    if (v.horas_estimadas !== '' && v.horas_estimadas !== inicial.horas_estimadas) out.horas_estimadas = Number(v.horas_estimadas)
    onConfirmar(out)
  }
  const mal = (k) => marcadas.includes(k) || (k === 'fecha_compromiso' && marcadas.includes('fecha_compromiso_pasada'))
  const inp = (k) => `input ${mal(k) ? '!border-rose-400' : ''}`
  const lbl = 'block text-xs font-medium text-gray-500 mb-1'

  return (
    <Modal title={t('ot.asignar.plan.titulo', { ot: ot.codigo })} onClose={onClose}>
      <form onSubmit={confirmar} className="space-y-4 text-sm">
        <p className="rounded-lg bg-amber-50 border border-amber-200 px-3 py-2 text-amber-900">
          {t('ot.asignar.plan.explica', { persona: persona.nombre, ot: ot.codigo })}
          {faltan.length > 0 && !error && (
            <span className="block mt-1 text-xs">{t('ot.asignar.plan.faltan', { lista: faltan.map(f => t(`ot.faltan.${f}`, { defaultValue: f })).join(', ') })}</span>
          )}
        </p>
        <div>
          <span className={lbl}>{t('ot.campos.prioridad')} *</span>
          <div className={`inline-flex rounded-lg border p-0.5 ${mal('prioridad') ? 'border-rose-400' : 'border-gray-200'}`}>
            {PRIORIDADES.map(p => (
              <button key={p} type="button" onClick={() => set('prioridad', p)}
                className={`px-3 py-1 rounded-md text-sm font-medium ${v.prioridad === p ? 'bg-gray-900 text-white' : 'text-gray-600 hover:text-gray-900'}`}>
                {t(`ot.prioridades.${p}`)}
              </button>
            ))}
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <label className={lbl}>{t('ot.campos.fecha_compromiso')} *</label>
            <input type="date" className={inp('fecha_compromiso')} value={v.fecha_compromiso}
              min={v.fecha_compromiso === inicial.fecha_compromiso && inicial.fecha_compromiso ? undefined : hoyLocal()}
              onChange={e => set('fecha_compromiso', e.target.value)} />
          </div>
          <div>
            <label className={lbl}>{t('ot.campos.horas_estimadas')}</label>
            <input type="number" min="0" step="0.5" className="input" value={v.horas_estimadas}
              placeholder={t('ot.admision.opcional')} onChange={e => set('horas_estimadas', e.target.value)} />
          </div>
          <div>
            <label className={lbl}>{t('ot.campos.grupo')} *</label>
            <select className={inp('grupo')} value={v.grupo_id} onChange={e => elegirGrupo(e.target.value)}>
              <option value="">{t('ot.nueva.elegir')}</option>
              {grupos.map(g => <option key={g.id} value={g.id}>{g.nombre}</option>)}
            </select>
          </div>
          <div>
            <label className={lbl}>{t('ot.campos.responsable')} *</label>
            <select className={inp('responsable')} value={v.responsable_id} disabled={!v.grupo_id} onChange={e => set('responsable_id', e.target.value)}>
              <option value="">{t('ot.nueva.elegir')}</option>
              {miembrosDe(grupos, v.grupo_id).map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
              {/* a responsable from before (monday) not in the group stays visible until changed */}
              {v.responsable_id && v.responsable_id === inicial.responsable_id && ot.responsable
                && !miembrosDe(grupos, v.grupo_id).some(m => String(m.id) === v.responsable_id)
                && <option value={v.responsable_id}>{typeof ot.responsable === 'string' ? ot.responsable : ot.responsable.nombre}</option>}
            </select>
            {!v.grupo_id && <p className="text-[11px] text-gray-400 mt-1">{t('ot.planificar.primeroGrupo')}</p>}
            {v.grupo_id && !miembrosDe(grupos, v.grupo_id).length && <p className="text-[11px] text-amber-700 mt-1">{t('ot.planificar.grupoSinPersonal')}</p>}
          </div>
        </div>
        {marcadas.length > 0 && (
          <p className="text-xs text-rose-700">
            {t('ot.asignar.plan.revisa', { lista: marcadas.map(f => t(`ot.faltan.${f}`, { defaultValue: f })).join(', ') })}
          </p>
        )}
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose}
            className="bg-white border border-gray-200 text-gray-600 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-50">
            {t('ot.asignar.cancelar')}
          </button>
          <button type="submit" disabled={ocupado}
            className="bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 disabled:opacity-50">
            {t('ot.asignar.plan.confirmar')}
          </button>
        </div>
      </form>
    </Modal>
  )
}
